
import { Component, Prop, Vue } from 'vue-property-decorator'
import MultiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

@Component({
  components: {
    MultiSelect
  }
})
export default class DropDown extends Vue {
  @Prop({ type: Array, required: true }) options!: string[]
  @Prop({ type: Function, required: true }) select!: any
  @Prop({ type: String, required: true }) value!: string
  @Prop({ type: String, default: '' }) placeholder!: string
}
